export default{
    portalUrl:"https://app-promineompp-portal-api-release.azurewebsites.net/api/",
    portalReadTokenUrl:"https://app-promineompp-portal-api-release.azurewebsites.net/api/azureadtoken"
}